import { render } from "./CompleteTextWait.vue?vue&type=template&id=7312349d&scoped=true&ts=true"
import script from "./CompleteTextWait.vue?vue&type=script&lang=ts"
export * from "./CompleteTextWait.vue?vue&type=script&lang=ts"

import "./CompleteTextWait.vue?vue&type=style&index=0&id=7312349d&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/vars.autocall.ai/vars.autocall.ai/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7312349d"]])

export default __exports__